<div class="container">
  <footer style="margin:0 auto; text-align: center; margin-top:3%">
    <p style="text-align: justify; text-justify: auto; font-size: 1.0em;">
      By providing your information, either on paper, electronically, or through a website, you consent to us storing and using your
      information for case administration purposes only. Our site uses tracking technologies to tailor your experience and understand
      how you and other visitors use our site. By continuing to navigate this site you consent to use of these tracking technologies.
      For more information on how we use your personal data, please read our <a style="color:#0066cb" href="https://abdatacaadstorage1.blob.core.windows.net/privacy/PrivacyPolicy.pdf"
                                                                                target="_blank">Privacy Policy</a>.
    </p>
    <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-6 text-center">
        <img src="./assets/ABdata_logo_highres_ small.jpg" class="img-responsive pull-left app-fixed-image" /><br />
        <p style="font-size:1.0em">&copy; 2026 - Non Bank ATM Surcharge Settlement All rights reserved.</p>
      </div>
      <div class="col-md-3"></div>
    </div>
    <br />
  </footer>
</div>
